
import { mapState, mapStores } from "pinia";
import { defineComponent } from "vue";
import { NavigationFailure } from "vue-router";
import { useAdvancedViewStore } from "~/store/advanced-view.store";
import { useDashboardStore } from "~/store/dashboard.store";
import { useStationStore } from "~/store/station.store";
import { useWidgetStore } from "~/store/widgets.store";
import { useAuthStore } from "../store/auth.store";

export default defineComponent({

    props: {
        brandIcon: { type: String, default: require('../../img/elichens-logo-1200px.png').default }
    },

    data() {
        return {
            showProfileMenu: false,
            tenantIcon: this.brandIcon,
        }
    },

    computed: {
        ...mapStores(useAuthStore),
        ...mapState(useAuthStore, ['user']),

        userAvatar(): string {

            if(!this.user) {
                return '';
            }

            if (this.user && this.user.imageUrl) {
                return this.user.imageUrl;
            }

            const names: string[] = this.user.email.split('@')[0].split('.');

            if (names.length === 0) {
                return this.buildUiAvatarUrl('John', 'Doe');
            }

            if (names.length === 1) {
                return names[0].length >= 2 ? this.buildUiAvatarUrl(names[0].charAt(0), names[0].charAt[1]) : this.buildUiAvatarUrl('John', 'Doe');
            }

            return this.buildUiAvatarUrl(names[0], names[1]);
        }
    },

    async mounted(): Promise<void> {
        if(this.authStore.isLogged) {
            this.authStore.fetchUser();
        }
    },

    methods: {

        logout(): Promise<void | NavigationFailure> {
            return this.authStore.logout().then(() => {
                useStationStore().$reset();
                useDashboardStore().$reset();
                useAdvancedViewStore().$reset();
                useWidgetStore().$reset();
                return this.$router.push('/login');
            });
        },

        toggleUserProfileMenu(event: Event): void {
            event.stopPropagation();
            this.showProfileMenu = !this.showProfileMenu;
        },

        /**
         * Generate url for ui avatar.ui avatar generate url  
         * @param name 
         * @param surname 
         */
        buildUiAvatarUrl(name: string, surname: string): string {
            const regex = /[^a-zA-Z ]/g;
            return `https://ui-avatars.com/api/?name=${name.replace(regex, "")}${surname ? '+' + surname.replace(regex, ""): ''}&background=66BA7E&size=256&bold=true&color=ffff`;
        }
    }
});
